
import Component from 'vue-class-component';
import {
  FilesRequirementViewModel,
  PracticeDetailsModel,
  FileModel,
  RequirementsClient
} from "@/api-client";
import {Prop} from "vue-property-decorator";
import RequirementSummary from "@/features/applications/components/RequirementSummary";
import Files from "../../../../components/Files.vue";

@Component({
  components: {
    Files
  }
})
export default class FilesRequirementSummary extends RequirementSummary {

  @Prop({required: true})
  requirement!: FilesRequirementViewModel;

  chosenFiles: FileModel[] | null = null;
  chosenPracticeDetails: PracticeDetailsModel[] = [];

  async created() {
    if (this.requirementValue) {
      this.chosenFiles = (await new RequirementsClient().chosenFiles(this.application.id, this.requirement.id));
    }
  }
  
  async getDownloadUrl(fileId: string): Promise<string> {
    return (await new RequirementsClient().downloadFile(fileId, this.application.id, this.requirement.id)).url;
  }

  get showChosen(){
    return this.chosenFiles && this.chosenFiles.length > 0
  }
}
